



























import {Component, Prop, Vue} from 'vue-property-decorator'
import VueRangeSlider from 'vue-range-component'
import 'vue-range-component/dist/vue-range-slider.css'
import InputCommon from '@/components/lib/InputCommon.vue'
import {Range} from './models'

@Component({
  components: {
    VueRangeSlider,
    InputCommon
  }
})
export default class InputRange extends Vue {
  @Prop() readonly value!: Range
  @Prop({ default: 0 }) readonly min?: number
  @Prop({ default: 100 }) readonly max?: number
  @Prop({ default: false }) readonly withInputs?: boolean
  @Prop({ default: false }) readonly withUnderline?: boolean
  @Prop({ default: false }) readonly simple?: boolean
  @Prop({ default: true }) readonly show?: boolean

  get rangeValue(): Range {
    return this.value;
  }
  set rangeValue(value: Range) {
    let oldValue = this.value;
    if (oldValue[0] !== value[0] || oldValue[1] !== value[1]) {
      this.$emit('input', value);
    }
  }

  private formatter = (value: string): string => {
    return this.simple ? '' : value;
  }

}
